import React, { useState } from "react";
import "./CustomerLimitPage.css";
import { useLocalSearch } from "../../hooks/useLocalSearch";
import { useToast } from "../../components/Toast/ToastContainer";
const CustomerLimitPage = () => {
    // State filters
    const [filters, setFilters] = useState({
        maKhachHang: "",
        soGTTT: "",
    });
    const toast = useToast();
    // State dữ liệu bảng và phân trang
    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;
    const [isLoading, setIsLoading] = useState(false);
    const { searchTerm, setSearchTerm, filteredData } = useLocalSearch(data);
    // State cho phần tổng hợp (Summary Bar)
    const [summary, setSummary] = useState({
        daDung: 0,
        nop: 0,
        rut: 0,
        conLai: 0,
    });

    // Hàm format tiền tệ
    const formatCurrency = (value) => {
        if (!value && value !== 0) return "0";
        return new Intl.NumberFormat('vi-VN').format(parseFloat(value));
    };

    // Hàm gọi API
    const fetchData = async (page = 1) => {
        setIsLoading(true);
        try {
            const token = localStorage.getItem("access_token");

            const payload = {
                customer_code: filters.maKhachHang || "",
                identity_number: filters.soGTTT || "",
                page: page,
                page_size: pageSize
            };

            const response = await fetch('https://api.bvb.cybertech.com.vn/api/v1/admin/queries/customers/limits', {
                method: 'POST',
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error("Lỗi API");
            }

            const result = await response.json();
            console.log("ket qua customer",result);
            if (result.transactions) setData(result.transactions);
            if (result.total_transactions) setTotalRecords(result.total_transactions);
            // Cập nhật Summary
            setSummary({
                daDung: result.limit_used,
                conLai: result.limit_remaining,
                nop: result.deposit_amount,
                rut: result.withdraw_amount
            });

            // Cập nhật Table
            setData(result.transactions || []);
            setTotalRecords(result.total_transactions || 0);
            setCurrentPage(page);

        } catch (error) {
            console.error("Lỗi tải dữ liệu:", error);
            setData([]);
            setTotalRecords(0);
            setSummary({ daDung: 0, nop: 0, rut: 0, conLai: 0 });
        } finally {
            setIsLoading(false);
        }
    };

    // KHÔNG SỬ DỤNG useEffect ĐỂ GỌI API KHI MOUNT

    const handleChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };

    const handleSearch = () => {
        // Kiểm tra xem có ít nhất một trường filter được nhập hay không
        const hasFilter = Object.values(filters).some(value => value.trim() !== "");

        if (!hasFilter) {
            toast.error("Vui lòng nhập ít nhất một thông tin để tìm kiếm.");
            return;
        }

        fetchData(1);
    };

    const handleReset = () => {
        setFilters({ maKhachHang: "", soGTTT: "" });
        // Reset thì clear bảng luôn cho sạch (hoặc giữ nguyên tùy ý)
        setData([]);
        setSummary({ daDung: 0, nop: 0, rut: 0, conLai: 0 });
        setTotalRecords(0);
    };

    const handlePageChange = (newPage) => {
        const totalPages = Math.ceil(totalRecords / pageSize);
        if (newPage > 0 && newPage <= totalPages) {
            fetchData(newPage);
        }
    };

    const totalPages = Math.ceil(totalRecords / pageSize);

    return (
        <div className="customer-limit-container">
            <h2 className="page-title">Truy vấn hạn mức ngày/khách hàng</h2>

            {/* FORM TÌM KIẾM */}
            <div className="filter-card">
                <div className="filter-grid">
                    <div className="filter-item">
                        <label>Mã khách hàng</label>
                        <input
                            type="text"
                            name="maKhachHang"
                            value={filters.maKhachHang}
                            onChange={handleChange}
                            placeholder="Nhập mã khách hàng"
                        />
                    </div>

                    <div className="filter-item">
                        <label>Số GTTT</label>
                        <input
                            type="text"
                            name="soGTTT"
                            value={filters.soGTTT}
                            onChange={handleChange}
                            placeholder="Nhập số GTTT"
                        />
                    </div>
                </div>

                <div className="filter-actions">
                    <button className="btn-secondary" onClick={handleReset}>
                        Xóa lọc
                    </button>
                    <button className="btn-primary" onClick={handleSearch} disabled={isLoading}>
                        {isLoading ? "Đang tìm..." : "Tìm kiếm"}
                    </button>
                </div>
            </div>

            {/* KẾT QUẢ TÌM KIẾM */}
            <div className="result-header">
                <h3 className="result-title">Kết quả tìm kiếm</h3>

                <div className="search-inline">
                    <img src="/icons/icons8-search-100.png" alt="search" className="search-icon" />
                    <input
                        type="text"
                        placeholder="Tìm kiếm nhanh trong bảng..."
                        value={searchTerm} // 1. Gắn giá trị vào state
                        onChange={(e) => setSearchTerm(e.target.value)} // 2. Khi gõ thì cập nhật state
                    />
                </div>
            </div>

            {/* SUMMARY BAR */}
            <div className="summary-bar">
                <div className="summary-row">
                    <span>HẠN MỨC ĐÃ DÙNG: {formatCurrency(summary.daDung)}</span>
                    <span className="green">
                        SỐ TIỀN NỘP: <span className="value">{formatCurrency(summary.nop)}</span>
                    </span>
                    <span className="red">
                        SỐ TIỀN RÚT: <span className="value">{formatCurrency(summary.rut)}</span>
                    </span>
                </div>

                <div className="summary-row">
                    <span>HẠN MỨC CÒN LẠI: {formatCurrency(summary.conLai)}</span>
                </div>
            </div>

            {/* TABLE */}
            <div className="table-wrapper">
                <table className="result-table">
                    <thead>
                        <tr>
                            <th>Mã KH</th>
                            <th>Số tiền</th>
                            <th>Phí VAT</th>
                            <th>Loại giao dịch</th>
                            <th>Trạng thái</th>
                            <th>Số tài khoản</th>
                            <th>Tên tài khoản</th>
                            <th>Người thực hiện</th>
                            <th>ID Đại lý</th>
                            <th>Tên đại lý</th>
                        </tr>
                    </thead>

                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>Đang tải dữ liệu...</td>
                            </tr>
                        ) : filteredData.length > 0 ? (
                            filteredData.map((row, i) => (
                                <tr key={i}>
                                    <td>{row.cif_number}</td>
                                    <td className="text-right">{formatCurrency(row.amount)}</td>
                                    <td className="text-right">{formatCurrency(row.fee)}</td>
                                    <td>{row.transaction_type}</td>
                                    <td>{row.status}</td>
                                    <td>{row.account_number}</td>
                                    <td>{row.account_name}</td>
                                    <td>{row.performed_by}</td>
                                    <td>{row.agent_id}</td>
                                    <td>{row.agent_name}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="10" style={{ textAlign: "center" }}>
                                    {/* Logic hiển thị thông báo */}
                                    {data.length > 0 && searchTerm
                                        ? "Không tìm thấy kết quả phù hợp"
                                        : "Không có dữ liệu"}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* PAGINATION */}
            {totalRecords > 0 && (
                <div className="pagination">
                    <span>
                        Số lượng bản ghi: {filteredData.length}/{totalRecords} (trên {pageSize} bản ghi/trang)
                    </span>

                    <div className="pager">
                        <button
                            disabled={currentPage === 1 || isLoading}
                            onClick={() => handlePageChange(currentPage - 1)}
                        >
                            Trước
                        </button>
                        <button className="active">{currentPage}</button>
                        <button
                            disabled={currentPage === totalPages || isLoading}
                            onClick={() => handlePageChange(currentPage + 1)}
                        >
                            Sau
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CustomerLimitPage;